module.exports = __webpack_public_path__ + "img/kantoor.e4cb28ee.jpg";